import { Injectable } from '@angular/core';

// campfire
import { ConfigService, ProductService } from '@campfire-nx/api';

import { EXTRAS_CONSTANTS } from '../constants/policy.constants';

interface ICoverInterface {
  policy_type: string;
  extras: any;
}

@Injectable({
  providedIn: 'root'
})
export class PolicyExtrasService {
  constructor(
    private configService: ConfigService,
    private productService: ProductService
  ) { }

  async getFormattedLegacyExtras(phase: any, policy: any) {
    const policyCovers = await this.productService.detail(policy.product.slug, 'covers');
    const policyExtras = this.getPolicyExtrasByType(policy.policy_type, policyCovers.covers);
    // using policyExtras to map extras for legacy

    const extras: { active: any[], additional: any[] } = {
      active: [],
      additional: []
    };
    
    if (phase.extras) {
      for (const [key, value] of Object.entries(phase.extras)) {
        if (value && (['SF', 'arrang_fee'].indexOf(key) === -1)) {
          extras.active.push({
            settings: {
              ...EXTRAS_CONSTANTS.active_setting.settings,
              title: EXTRAS_CONSTANTS.extra_details[key as keyof typeof EXTRAS_CONSTANTS.extra_details].label || '',
              content: EXTRAS_CONSTANTS.extra_details[key as keyof typeof EXTRAS_CONSTANTS.extra_details].info || '',
              iconName: ''
            }}
          );
        } else if ((['SF', 'arrang_fee'].indexOf(key) === -1)) {
          extras.additional.push({
            settings: {
              ...EXTRAS_CONSTANTS.additional_setting.settings,
              title: EXTRAS_CONSTANTS.extra_details[key as keyof typeof EXTRAS_CONSTANTS.extra_details].label || '',
              content: EXTRAS_CONSTANTS.extra_details[key as keyof typeof EXTRAS_CONSTANTS.extra_details].info || '',
              iconName: ''
            }}
          );
        }
      }
    }

    return extras;
  }

  getFormattedExtras(policyExtras: any) {
    const extras: { active: any[], additional: any[] } = {
      active: [],
      additional: []
    };
    
    if (policyExtras) {
      Object.entries(policyExtras).forEach(([key, extra]: [string, any]) => {
        if (extra.is_included) {
          extras.active.push({
            settings: {
              ...EXTRAS_CONSTANTS.active_setting.settings,
              title: extra.label || '',
              content: extra.description || '',
              link: extra.info_page || '',
              iconName: extra.icon || ''
            }
          });
        } else { 
          extras.additional.push({ 
            settings: {
            ...EXTRAS_CONSTANTS.additional_setting.settings, 
              title: extra.label || '',
              content: extra.description || '',
              iconName: extra.icon || ''
            }
          });
        }
      });
    }

    return extras;
  }

  getPolicyExtrasByType = (policyType: string, covers: any) => {
    const filteredPolicy = Object.values(covers).find((cover) => (cover as ICoverInterface).policy_type === policyType) as ICoverInterface | undefined;
    
    return filteredPolicy ? filteredPolicy.extras : null;
  };
}